import { Component, OnInit, ViewChild } from '@angular/core';
import moment from 'moment';
import { NgForm } from '@angular/forms';
import { Router } from '@angular/router';
//service imports
import { UtilityService } from '../../../core/services/utility.service';
import { PortalSettingsService } from '../../../core/services/portal-settings.service';
import { HiringService } from 'src/app/pages/hiring/services/hiring.service';

@Component({
  selector: 'app-identification',
  templateUrl: './identification.component.html',
  styleUrls: ['./identification.component.css']
})
export class IdentificationComponent implements OnInit {
  @ViewChild('Idenform', { static: false }) Idenform: NgForm;
  portalSettings: any;
  formData: { [key: string]: any } = {};
  mobileMode: boolean;
  companyName: any;
  hideFederalMsgSelfIden: boolean = false;
  alreadySubmitted: boolean;
  raceList: any[] = [];
  validateCheck: boolean;
  alert: string;
  format: string;
  datePickerOptions: { dateInputFormat: string; containerClass: string; showTodayButton: boolean; showClearButton: boolean; clearPosition: string; showWeekNumbers: boolean };

  constructor(private utilityService: UtilityService, portalSettingsService: PortalSettingsService, private hiringService: HiringService, private router: Router) {
    this.portalSettings = portalSettingsService.getPortalSettings();
    this.format = utilityService.getDateFormat().toUpperCase();
  }

  ngOnInit(): void {
    this.mobileMode = this.utilityService.isMobileMode();
    this.datePickerOptions = { dateInputFormat: this.format, containerClass: "theme-blue", showTodayButton: true, showClearButton: true, clearPosition: "left", showWeekNumbers: false };
    this.formData = {};
    this.companyName = this.portalSettings.CareerJobCompanyName.ConfigValue;
    this.hideFederalMsgSelfIden = this.portalSettings.HideFederalMsgSelfIden.ConfigValue == "1";
    this.getInfoByOnboardID();
    this.getRaceCodes();
  }

  getInfoByOnboardID() {
    this.hiringService.getInfoByOnboardID().then((response: any) => {
      if (response != null) {
        this.formData.selectedRace = (response.RaceEthnic != null ? response.RaceEthnic.toString() : response.RaceEthnic);
        this.formData.selectedSex = response.Gender;
        this.formData.selectedVeteran = response.Veteran;
        this.formData.selectedDisability = response.Disability;
        this.formData.GenderIdentity = response.GenderIdentity;
        this.formData.GenderIdentity_OtherDesc = response.GenderIdentity_OtherDesc;
        this.formData.Veteran_Disabled = response.Veteran_Disabled;
        this.formData.Veteran_AFServiceMedal = response.Veteran_AFServiceMedal;
        this.formData.Veteran_ActiveDutyWartime = response.Veteran_ActiveDutyWartime;
        if (response.Veteran_DischargeDate != null)
          this.formData.Veteran_DischargeDate = new Date(parseInt(moment.utc(response.Veteran_DischargeDate).format("YYYY")), parseInt(moment.utc(response.Veteran_DischargeDate).format("MM")) - 1, parseInt(moment.utc(response.Veteran_DischargeDate).format("DD")), 0, 0, 0, 0);

        if (response.DateSubmitted != null)
          this.alreadySubmitted = true;
        else
          this.alreadySubmitted = false
      }
    });
  }

  getRaceCodes() {
    this.hiringService.getRaceCodes().then((response: any) => {
      this.raceList = response;
      this.raceList.push({ Race: "X", Description: "I do not wish to answer" });
    });
  }

  saveIden() {
    if (this.Idenform.form.invalid) {
      this.validateCheck = true;
      window.scrollTo(0, 0);
      this.alert = "Please fill out all required fields.";
    }
    else {
      this.alert = null;
      if (this.formData.selectedRace != null) {
        this.raceList.forEach((val: any) => {
          if (val.Race.trim() == this.formData.selectedRace.trim())
            this.formData.selectedRace = val.Race;
        });
      }

      this.hiringService.updateSelfInfoByOnboardID(null, this.formData.selectedRace, this.formData.selectedSex, this.formData.selectedVeteran, this.formData.selectedDisability,
        this.formData.GenderIdentity, this.formData.GenderIdentity_OtherDesc,
        this.formData.Veteran_Disabled, this.formData.Veteran_AFServiceMedal, this.formData.Veteran_ActiveDutyWartime,
        (this.formData.Veteran_DischargeDate != null ? moment(this.formData.Veteran_DischargeDate).format("YYYY/MM/DD") : null)).then((response: any) => {
          if (response != null) {
            this.validateCheck = false;
            if (response.success) {
              this.router.navigate(['/careers/tasks']);
            }
            else {
              this.alert = response.error;
            }
          }
        });
    }
  }

  genderUpdate() {
    if (this.formData.GenderIdentity != "O") {
      this.formData.GenderIdentity_OtherDesc = null;
    }
  }

  vetUpdate() {
    this.formData.Veteran_Disabled = null;
    this.formData.Veteran_AFServiceMedal = null;
    this.formData.Veteran_ActiveDutyWartime = null;
    this.formData.Veteran_DischargeDate = null;
  }

}